export const getTextContentFrom = (children: React.ReactNode): string => {
  const elem = Array.isArray(children) ? children[0] : children;
  if (!elem) return '';

  if (typeof elem === 'string') {
    return elem;
  }
  if (elem === true || typeof elem === 'number') return elem.toString();

  if ('props' in elem) {
    return elem.props.children.toString();
  }

  return '';
};
